/* src/app/views/area-publica/detalhes-projeto/setores-prioritarios-public/setores-prioritarios-public.component.scss */
.margin {
  margin: 2%;
}
.card .close-btn {
  color: #C21E00;
}
.card .border {
  height: 149px;
  border: 2px solid #F0F0F0;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1607843137);
  border-radius: 4px;
}
.card .border .card-margin {
  margin: 3%;
}
.card .title {
  font-weight: 600;
  text-align: left;
  font-size: normal normal medium 20px/24px Montserrat, sans-serif;
  letter-spacing: 0px;
  color: #2E3241;
}
.card .description {
  text-align: left;
  font-size: normal normal normal 16px/26px Montserrat, sans-serif;
  letter-spacing: 0px;
  color: #757575;
}
.truncate {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
/*# sourceMappingURL=setores-prioritarios-public.component.css.map */
